import { RECEPTOR_TYPE } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import { GatekeeperFlag, IsGatekeeperEnabled } from '../../context/Gatekeeper'
import { getAllReceptorTemplates, Receptor } from '../../xgenerated'

export const getAllReceptorTemplatesFiltered = (
  type: RECEPTOR_TYPE,
  includeGA = false,
): Receptor[] => {
  let receptorTemplates: Receptor[] = getAllReceptorTemplates()
  // code to filter out receptor by modelid
  if (!IsGatekeeperEnabled(GatekeeperFlag.MIRADORE_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-miradore',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.JUMPCLOUD_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-jumpcloud',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.KNOWBE4_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-knowbe4',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.SLACK_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-slack',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.SONARQUBE_CLOUD_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-sonarqubecloud',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.FRESHDESK_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-freshdesk',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.JSM_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-jsm',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.CONFLUENCE_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-confluence',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.ZENDESK_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-zendesk',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.HUBSPOT_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-hubspot',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.OKTA_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-okta',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.AZUREBOARDS_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-azuredevops',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.RIPPLING_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-rippling',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.JIT_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-jit',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.JIRA_WORKFLOW)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-jira-workflow',
    )
  }

  if (!IsGatekeeperEnabled(GatekeeperFlag.DOCEBO_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-docebo',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.SALESFORCE_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-salesforce',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.ONSPRING_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-onspring',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.SMARTSUITE_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-smartsuite',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.CONFLUENCE_DMS)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-confluence-dms',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.CROWDSTRIKE_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-crowdstrike',
    )
  }
  if (!IsGatekeeperEnabled(GatekeeperFlag.RAPID7_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-rapid7',
    )
  }

  if (!IsGatekeeperEnabled(GatekeeperFlag.INCIDENTIO)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-incidentio',
    )
  }

  if (!IsGatekeeperEnabled(GatekeeperFlag.SHORTCUT_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-shortcut',
    )
  }

  if (!IsGatekeeperEnabled(GatekeeperFlag.NOTION_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-notion',
    )
  }

  if (!IsGatekeeperEnabled(GatekeeperFlag.AXONIUS_RECEPTOR)) {
    receptorTemplates = receptorTemplates.filter(
      (receptorTemplate) => receptorTemplate.modelid !== 'trr-axonius',
    )
  }

  receptorTemplates = receptorTemplates.filter(
    (receptorTemplate) =>
      receptorTemplate.type === type || (includeGA && receptorTemplate.ga),
  )
  return receptorTemplates
}
